import type {
  DiscountTargetEnum,
  DiscountType,
  DiscountEffectType
} from "@shared/graphql.types";

export const getDiscountEffectsByTargetType = (
  targetType: DiscountTargetEnum,
  discounts: Array<DiscountType> = []
): DiscountEffectType[] => {
  if (!discounts?.length) return [];

  const discountsByTargetType: DiscountEffectType[] = [];

  discounts.forEach((d) => {
    if (d.state === "applicable") {
      d.effects.forEach((e) => {
        if (e.target === targetType) {
          discountsByTargetType.push(e);
        }
      });
    }
  });

  return discountsByTargetType;
};
